import React, { useContext, useEffect } from "react";
import Box from "@mui/material/Box";
import { useAuthenticated } from "react-admin";
import { useParams } from "react-router";
import { StoreContext } from "./../../store/Store";
import { APIContext } from "../../store/APIStore";


const Dashboard = () => {
  useAuthenticated();
  const { eventId } = useParams() as any;
  const [state, dispatch] = useContext(StoreContext);
  const api = useContext(APIContext);

  useEffect(() => {
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = () => {
    if (eventId && !state.selectedEvent) {
      fetchSelectedEvent();
    }
  };

  const fetchSelectedEvent = async () => {
    try {
      const event = await api.eventService.getEvent({ id: eventId });
      dispatch({ type: "SET_SELECTED_EVENT", payload: event });
    } catch (error: any) {
      console.log(error);
    }
  };

  if (!eventId || eventId === "undefined") {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        paddingTop="50px"
      >
        Please, select an event!
      </Box>
    );
  }

  return (
    <Box sx={{flexGrow:'1'}}>
      Dashboard view - selected event:{" "}
      {state.selectedEvent && state.selectedEvent.id}
    </Box>
  );
};

export default Dashboard;
